import { Controller } from "@hotwired/stimulus"

/**
 * Competition Expand Controller
 *
 * Controls the visibility of overflow models in competition sections.
 * Uses a smooth slide animation via CSS grid-template-rows.
 * Lazy-loads middle competitors via Turbo Frame on first expand.
 */
export default class extends Controller<HTMLElement> {
  static targets = ["overflow", "inner", "button", "icon", "text", "frame"]

  declare readonly overflowTarget: HTMLElement
  declare readonly innerTarget: HTMLElement
  declare readonly buttonTarget: HTMLButtonElement
  declare readonly iconTarget: SVGElement
  declare readonly textTarget: HTMLElement
  declare readonly hasOverflowTarget: boolean
  declare readonly hasInnerTarget: boolean
  declare readonly hasFrameTarget: boolean
  declare readonly frameTarget: HTMLElement

  private expanded = false
  private loaded = false

  toggle(): void {
    this.expanded = !this.expanded

    if (this.hasOverflowTarget) {
      this.overflowTarget.classList.toggle(
        "competition-overflow--expanded",
        this.expanded
      )
    }

    if (this.hasInnerTarget) {
      this.innerTarget.inert = !this.expanded
    }

    this.buttonTarget.setAttribute("aria-expanded", String(this.expanded))

    this.textTarget.textContent = this.expanded
      ? "Show less"
      : this.textTarget.dataset.collapsedText || "Show more"

    this.iconTarget.style.transform = this.expanded ? "rotate(180deg)" : ""

    // Trigger lazy load on first expand
    if (this.expanded && !this.loaded && this.hasFrameTarget) {
      const src = this.frameTarget.dataset.lazySrc
      if (src) {
        this.frameTarget.setAttribute("src", src)
        this.loaded = true
      }
    }
  }
}
